<template>
    <div>
        <v-layout justify-center row ><v-icon style="font-size: 250px;">{{icon}}</v-icon></v-layout >
        <v-layout justify-center row><h3 class = "font-weight-regular"> {{data}}  </h3></v-layout >
    </div>
</template>

<script>
    export default {
        props : ['icon', 'data'],
    }
</script>